import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-country-name-reminder',
  templateUrl: './country-name-reminder.component.html',
  styleUrls: ['./country-name-reminder.component.scss']
})
export class CountryNameReminderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
